import { AssessmentStatus as Assessment_Status_Enum } from '@risksmart-app/domain/src/types/consts/assessment-status';
import type { InsertOversightAssessmentMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  GetAllOversightAssessmentsDocument,
  GetOversightAssessmentByIdDocument,
  InsertOversightAssessmentDocument,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

import type {
  InsertOversightAssessmentInput,
  InsertOversightAssessmentRequest,
} from './types';

export const useInsertOversightAssessment = createMutationHook({
  name: 'insertOversightAssessment',
  isIdempotentCreate: true,
  mutationOptions: (trpc, onSuccess, requestContext) =>
    trpc.frontend.oversight.insert.mutationOptions({
      onSuccess,
      trpc: { context: requestContext },
    }),
  mapInput: (
    variables: InsertOversightAssessmentInput
  ): InsertOversightAssessmentRequest => ({
    ...variables,
    Title: variables.Title ?? '',
    Summary: variables.Summary ?? '',
    Status: variables.Status ?? Assessment_Status_Enum.NotStarted,
  }),
  invalidate: (trpc) => [
    trpc.frontend.oversight.register.queryKey(),
    trpc.frontend.oversight.oversightAssessmentCount.queryKey(),
  ],
  mapResponse: (result: { Id: string }): InsertOversightAssessmentMutation => ({
    insertOversightAssessmentApi: {
      __typename: 'IdOutput',
      Id: result.Id,
    },
  }),
  graphqlDocument: InsertOversightAssessmentDocument,
  graphqlVariables: (variables: InsertOversightAssessmentInput) => ({
    object: variables,
  }),
  // The corresponding READS are NOT migrated and are cache-first, so a write
  // via tRPC still has to evict these or the Apollo-backed list/counter shows
  // pre-write data. Kept identical on both branches so they cannot drift.
  evictFields: ['oversight_assessment', 'oversight_assessment_aggregate'],
  refetchQueries: [
    GetOversightAssessmentByIdDocument,
    GetAllOversightAssessmentsDocument,
  ],
});
